import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState as rootState,
} from '../../../utils/redux';
import { APPOINTMENT_PROGRESS_TYPES } from '../progress-types';

export const consts = createReqConsts(
  'appointment-form',
  'inline-visits-time-slots',
  ['SHOW_ERROR_ALERT'],
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'appointments',
  type: 'get',
  slug: [
    'capacity_available_time_slots',
    {
      type: 'payload.query',
      queryParameter: 'location_id',
      selector: 'locationId',
    },
    {
      type: 'payload.query',
      queryParameter: 'service_id',
      selector: 'serviceId',
    },
    {
      type: 'payload.query',
      queryParameter: 'reason_type_id',
      selector: 'reasonTypeId',
    },
  ],
});

const defaultRequestReducer = createReqReducer(consts);

const initialState = {
  ...rootState,
};

export default function(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case consts.SEND: {
      return {
        ...initialState,
        sending: true,
      };
    }

    case consts.SUCCEED: {
      return {
        ...state,
        data: payload,
        sending: false,
        succeed: true,
      };
    }

    case APPOINTMENT_PROGRESS_TYPES.SET_CARE_USER:
    case APPOINTMENT_PROGRESS_TYPES.CLEAR: {
      return initialState;
    }

    default: {
      return defaultRequestReducer(state, action);
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/requests/inline-visits-time-slots.js